import { instanceKeycloak } from '../../keycloack';

export const getUser = () => {
  return new Promise((resolve, reject) => {
    instanceKeycloak
      .get('/admin/realms/PUV-FRONT/users?briefRepresentation=false')
      .then(async (response) => {
        console.log(response)
        const users = response.data;

        // Obtener los roles de Realm para cada usuario
        const usersWithRoles = await Promise.all(
          users.map(async (user) => {
            try {
              const rolesResponse = await instanceKeycloak.get(`/admin/realms/PUV-FRONT/users/${user.id}/role-mappings/realm`);
              const roles = rolesResponse.data.map((role) => {
                return {
                  id: role.id,
                  name: role.name,
                };
              });
              return { ...user, roles };
            } catch (error) {
              console.error('Error al obtener roles de usuario:', error);
              return user;
            }
          })
        );

        resolve(usersWithRoles); // Devolver los datos de usuario con roles
      })
      .catch((error) => reject(error));
  });
};

export const getRol = () => {
  return new Promise((resolve, reject) => {
    instanceKeycloak
      .get('/admin/realms/PUV-FRONT/roles')
      .then((response) => {
        // Filtra solo los roles deseados
        const rolesDeseados = response.data.filter((rol) => ['NOC', 'Monitoreo', 'Autor', 'Administrador'].includes(rol.name));

        resolve(rolesDeseados);
      })
      .catch((error) => reject(error));
  });
};

export const addUser = (userData) => {
  return new Promise((resolve, reject) => {
    // Agrega la contraseña temporal "pastemp" al objeto userData
    userData.credentials = [{ type: 'password', temporary: true, value: 'Contraseña' }];
    userData.requiredActions = ['UPDATE_PASSWORD'];

    instanceKeycloak
      .post('/admin/realms/PUV-FRONT/users', userData)
      .then((response) => {
        resolve(response.data); // Devuelve los datos del usuario creado
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const editUser = (userId, updatedUserData) => {
  return new Promise((resolve, reject) => {
    instanceKeycloak
      .put(`/admin/realms/PUV-FRONT/users/${userId}`, updatedUserData)
      .then((response) => {
        resolve(response.data); // Devolver los datos del usuario actualizado
      })
      .catch((error) => reject(error));
  });
};

export const deleteUser = (userId) => {
  return new Promise((resolve, reject) => {
    instanceKeycloak
      .delete(`/admin/realms/PUV-FRONT/users/${userId}`)
      .then(() => {
        resolve('Usuario eliminado correctamente');
      })
      .catch((error) => reject(error));
  });
};

export const updateStatus = (userId, newStatus) => {
  return new Promise((resolve, reject) => {
    const updatedUserData = { enabled: newStatus }; // Datos que deseas actualizar

    instanceKeycloak
      .put(`/admin/realms/PUV-FRONT/users/${userId}`, updatedUserData)
      .then((response) => {
        resolve(response.data); // Devolver los datos del usuario actualizado en Keycloak
      })
      .catch((error) => reject(error));
  });
};

export const addRol = (userId, rolesData) => {
  return new Promise((resolve, reject) => {
    instanceKeycloak
      .post(`/admin/realms/PUV-FRONT/users/${userId}/role-mappings/realm`, rolesData)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });
};

export const deleteRol = (userId, rolesToDelete) => {
  return new Promise((resolve, reject) => {
    instanceKeycloak
      .delete(`/admin/realms/PUV-FRONT/users/${userId}/role-mappings/realm`, {
        data: rolesToDelete.map((selectedRole) => ({
          id: selectedRole.id,
          name: selectedRole.name,
          clientRole: selectedRole.clientRole,
          composite: selectedRole.composite,
          containerId: selectedRole.containerId,
        })),
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(error));
  });
};

export const getUserIdWithLatestTimestamp = async () => {
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await instanceKeycloak.get('/admin/realms/PUV-FRONT/users');
    const users = response.data;

    if (users.length === 0) {
      return null; // Devuelve null si no hay usuarios
    }

    // Ordena los usuarios por createdTimestamp de forma descendente
    const sortedUsers = users.sort((a, b) => b.createdTimestamp - a.createdTimestamp);

    // Toma el id del usuario con el createdTimestamp más reciente (el primero en la lista ordenada)
    const userIdWithLatestTimestamp = sortedUsers[0].id;

    return userIdWithLatestTimestamp;
  } catch (error) {
    throw error;
  }
};
